import { useEffect } from "react";
import { Box, Button, Divider } from "@mui/material";
import { HeaderBlock } from "@colliers/colliers-b2c";
import { otOpenPreferenceCenter, otRenderCookiePolicy } from "../../utils/onetrust";

const CookiePolicy = () => {
    useEffect(() => {
        otRenderCookiePolicy();
    }, []);

    return (
        <>
            <HeaderBlock title="Cookie Policy" />
            <Box className="main-content display-flex">
                <Box
                    className="margin-auto"
                    sx={{
                        flexWrap: "wrap",
                        width: { xs: "100%", md: "75%", lg: "50%" },
                    }}
                >
                    <Box className="container onetrust-cookiepolicy" sx={{ py: 4 }}>
                        <Button
                            className="ot-sdk-show-settings btn btn__secondary onetrust-cookiesettings"
                            onClick={otOpenPreferenceCenter}
                        >
                            Cookie Settings
                        </Button>
                        <Divider className="margin-top-l margin-bottom-l" />
                        <Box id="ot-sdk-cookie-policy" className="onetrust-cookietable"></Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default CookiePolicy;
